
<div class="principal" id="style-2">
  <div class="force-overflow">
    <router-outlet></router-outlet>
  </div>
</div>
<script>
$(document).ready(function () {
        if (!$.browser.webkit) {
            $('.wrapper').html('<p>Sorry! Non webkit users. :(</p>');
        }
    });
</script>